import { Suspense, useEffect } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer, setOpen } from '../../redux/reducer/drawerSlice';
import PageLoader from '../loader/LoaderText';
import PolicyDrawerComponent from './policyDocument';
import DocumentDrawerComponent from './documents';
import ProjectMilestoneForm from './project-milestone';
import { TEMPLE, TEMPLE_SHADOW_HOVER } from '../common/templeStyles';

const CommonDrawerComponent = () => {
    const dispatch = useDispatch();
    const drawer = useSelector((state: any) => state.drawer);
    const open = useSelector((state: any) => state.drawer.open);

    const drawerWidthMapping: Record<string, number> = {
        xl: 1200,
        lg: 1000,
        md: 800,
        sm: 600,
    };

    const getDrawerWidth = () => {
        if (drawer.isFullScreen) return "100%";
        if (drawer.drawerWidth) {
            return drawerWidthMapping[drawer.drawerWidth];
        }
        return 1400; 
    };

    const handleClose = (newOpen: boolean) => () => {
        if (newOpen) {
            dispatch(setOpen(true));

            return;
        }
        if (!newOpen) {
            dispatch(closeDrawer());
            dispatch(setOpen(false));

        }
    };

    useEffect(() => {
        drawer?.tab !== 6 && drawer?.name && dispatch(setOpen(true))
    }, [drawer, dispatch])

    return (
        <Drawer
            anchor='right'
            open={open}
            sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(58, 42, 26, 0.45)' } }}
            PaperProps={{
                sx: {
                    maxWidth: getDrawerWidth(),
                    width: '100%',
                    overflowY: "unset",
                    backgroundColor: TEMPLE.cream,
                    boxShadow: TEMPLE_SHADOW_HOVER,
                },
            }}
        >
            <Box
                sx={{
                    background: `linear-gradient(135deg, ${TEMPLE.maroon} 0%, ${TEMPLE.saffronD} 60%, ${TEMPLE.saffron} 100%)`,
                    height: 59,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 2,
                    boxShadow: '0 2px 14px rgba(122, 30, 30, 0.25)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    padding: 2,
                }}
            >
                <Typography variant='h3' sx={{ color: '#fff' }}>{drawer.title}</Typography>
                <IconButton sx={{ color: '#fff', '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' } }} onClick={handleClose(false)}><CloseIcon /></IconButton>
            </Box>
            <Box sx={{ backgroundColor: TEMPLE.cream, minHeight: '100%' }}>
                <Suspense fallback={<PageLoader />}>
                <PolicyDrawerComponent handleClose={handleClose} />
                <DocumentDrawerComponent handleClose={handleClose}/>
                <DocumentDrawerComponent handleClose={handleClose}/>
                <ProjectMilestoneForm handleClose={handleClose}/>
                </Suspense>
            </Box>
        </Drawer>
    )
}

export default CommonDrawerComponent;